import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  cancelButtonText: {
    description: 'text for the cancel button in the FTU wizard footer',
    defaultMessage: 'Cancel',
    id: 'UO7Qar',
  },
  backButtonText: {
    description: 'text for the back button in the FTU wizard footer',
    defaultMessage: 'Back',
    id: 'Hlx65g',
  },
  nextButtonText: {
    description: 'text for the next button in the FTU wizard footer',
    defaultMessage: 'Continue',
    id: 'trPvD2',
  },
  finishButtonText: {
    description: 'text for the finish button in the FTU wizard footer',
    defaultMessage: 'Finish',
    id: 'QzJAiC',
  },
  skipButtonText: {
    description: 'text for the skip button in the FTU wizard footer',
    defaultMessage: 'Skip',
    id: '0NL9Yl',
  },
  addOrdersLaterButtonText: {
    description: 'text for the add orders later button in the FTU wizard footer',
    defaultMessage: 'Add orders later',
    id: 'k1AsSS',
  },
  closeDrawerButtonAriaLabel: {
    description: 'aria label for the close button in the drawer',
    defaultMessage: 'Close FTU Wizard',
    id: 'sJjx6X',
  },
  drawerHeaderText: {
    description: 'header text for the drawer',
    defaultMessage: 'Get Set Up',
    id: 'hBZ7mt',
  },
  stepProgress: {
    description: 'Progress indicator showing current step in wizard',
    defaultMessage: 'Step {currentStep} of {totalSteps}',
    id: 'O/oWYF',
  },
  inventorySyncUpdateConfigErrorTitle: {
    description: 'Error title when inventory sync configuration update fails',
    defaultMessage: 'Error updating inventory sync configuration',
    id: 'FKfZYr',
  },
  inventorySyncUpdateConfigErrorContent: {
    description: 'Error content when inventory sync configuration update fails',
    defaultMessage: 'Failed to update inventory sync configuration. Please try again.',
    id: 'bXRLr9',
  },
  inventoryTrackingEnableErrorTitle: {
    description: 'Error title when enabling inventory tracking fails',
    defaultMessage: 'Error enabling inventory tracking',
    id: 'VTobIc',
  },
  inventoryTrackingEnableErrorContent: {
    description: 'Error content when enabling inventory tracking fails',
    defaultMessage: 'Failed to enable inventory tracking. Please try again.',
    id: '5PW9UL',
  },
  stepPhoneNumber: {
    description: 'Label for phone number capture step in wizard',
    defaultMessage: 'Phone Number',
    id: '5rTQZa',
  },
});
